/** Site-wide brand mark (Shrut Ratnakar). */
import siteLogo from "./Org-Shrut Ratnakar.png";

export default siteLogo;

export const SITE_LOGO_ALT = "Shrut Ratnakar";
